<template>
  <v-container fluid>
    <v-row class="mb-4">
      <v-col
        class="
          box-white
          text-center
          py-1
          text-subtitle-2
          text-sm-subtitle-1
          text-md-subtitle-1
          text-lg-subtitle-1
          text-xl-subtitle-1
        "
      >
        {{ areaSelected ? areaSelected.name : "" }}
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row v-if="loading">
          <v-col cols="12" v-for="item in 6" :key="item" class="py-2">
            <v-skeleton-loader type="list-item-avatar-three-line" />
          </v-col>
        </v-row>
        <v-row v-else no-gutters>
          <v-col
            cols="12"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="12"
            v-for="item in analysis"
            :key="item._id"
          >
            <!-- <span>{{ item.folio }}</span> -->
            <ResultItem :folioAnalysis="item" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="overlayCenter" v-if="!loading && analysis.length <= 0">
      <p class="text-center">{{ translations.label_no_results }}</p>
    </div>
    <!-- copyright -->
    <v-footer class=" text-caption text-center d-flex justify-center" fixed>
      D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
    </v-footer>
  </v-container>
</template>

<script>
// vuex
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
//components
import ResultItem from "@/components/territory/ResultItem.vue";
export default {
  components: {
    ResultItem,
  },
  data: () => ({
    areaId: null,
    loading: false,
    analysis: [],
  }),
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["areaSelected"]),
  },
  async created() {
    try {
      this.loading = true;
      if (!this.areaSelected && this.$route.params.areaId) {
        let response = await this.getAreaById(this.$route.params.areaId);
        if (response) {
          if (!response.error) {
            this.SET_AREA_SELECTED(response.soilArea);
            await this.init();
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } else {
        this.init();
      }
    } catch (e) {
      this.loading = false;
      console.log(e);
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text: this.translations.advice_error,
        timeout: 4000,
      });
    }
  },
  methods: {
    ...mapActions("areasList", ["getAreaById"]),
    ...mapActions("samples", ["getAnalysisByArea"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("areasList", ["SET_AREA_SELECTED"]),
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    async init() {
      try {
        let response = await this.getAnalysisByArea(this.$route.params.areaId);
        if (response) {
          this.analysis = response.folios;
          this.loading = false;
        } else {
          this.loading = false;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } catch (e) {
        this.loading = false;
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
      this.SET_APPBAR_OPTIONS({
        leftButton: "back-arrow",
        funcLeftButton: this.goBack,
      });
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.box-white {
  background-color: white;
}
.overlayCenter {
  display: fixed;
  flex: 100%;
  top: 50%;
  left: 20%;
  right: 20%;
  bottom: 50%;
  z-index: 1;
  position: absolute;
}
</style>
